import { useCallback } from 'react';

import { hasNavigatorApi, hasWindow } from 'utils/browser.utils';

import { useClipboard } from 'hooks/useClipBoard';
import { useMobileShare } from 'hooks/useMobileShare';

export const useNavigatorShare = () => {
  const writeToClipboard = useClipboard();
  const mobileShare = useMobileShare();
  const navigatorShare = useCallback(
    async (data: ShareData) => {
      if (!hasWindow() || !data.url) return;

      try {
        if (hasNavigatorApi('share')) {
          await mobileShare(data);
        } else {
          await writeToClipboard(data.url);
        }
      } catch (e) {
        console.warn(e);
      }
    },
    [mobileShare, writeToClipboard],
  );

  return {
    navigatorShare,
  };
};
